<mat-card appearance="outlined" class="card-margin">
  <div mat-dialog-content>
      <div class="md-title header" class="title-padding">{{headLine}}</div>
        <mat-form-field>
          <mat-label>Contact Name</mat-label>
          <input matInput
                 [value]="fullName"
                 disabled
                 name="external_contact_detail_contactName"/>
        </mat-form-field>
        <div fxLayout="row">
          <mat-form-field>
            <mat-label>Phone</mat-label>
            <input matInput
                   value="{{contactObj?.phoneNumber | phoneNumber}}"
                   disabled
                   name="phoneNumber"/>
          </mat-form-field>
          <mat-form-field fxFlexOffset="5">
            <mat-label>Fax</mat-label>
            <input matInput
                   value="{{contactObj?.faxNumber | phoneNumber}}"
                   disabled
                   name="faxNumber"/>
          </mat-form-field>
        </div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput
               [value]="contactObj && contactObj.email ? contactObj.email : ''"
               readonly
               uiInputHref="mailto:{{contactObj?.email}}"
               name="email"/>
      </mat-form-field>
    <div fxLayout="row" *ngIf="(label === 'Location' && confirmationInfo)">
      <mat-form-field>
        <input matInput
               [value]="type ? contactObj && contactObj?.pointCd ? contactObj.pointCd : '' : contactObj?.dunsNbr"
               placeholder="{{label}}"
               disabled
               name="label"/>
      </mat-form-field>
      <mat-form-field fxFlexOffset="5">
        <mat-label>Meter</mat-label>
        <input matInput
               value="{{contactObj?.meter}}"
               disabled
               name="meter"/>
      </mat-form-field>
    </div>
      <mat-form-field *ngIf="(label !== 'Location' || !confirmationInfo)">
        <mat-label>{{label}}</mat-label>
        <input matInput
               [value]="type ? contactObj && contactObj?.pointCd ? contactObj.pointCd : '' : contactObj?.dunsNbr"
               disabled
               name="label"/>
      </mat-form-field>
    <mat-form-field>
      <mat-label>{{label}} Name</mat-label>
      <input matInput
             [value]="type ? contactObj && contactObj?.pointName ? contactObj.pointName : '' : contactObj?.baName"
             disabled
             name="label"/>
    </mat-form-field>
    <div fxLayout="row" *ngIf="(label === 'Location' && confirmationInfo && contactObj && (contactObj.area || contactObj.supplyBasin))">
      <mat-form-field>
        <mat-label>Area</mat-label>
        <input matInput
               value="{{contactObj?.area}}"
               disabled
               name="area"/>
      </mat-form-field>
      <mat-form-field fxFlexOffset="5">
        <mat-label>Supply Basin</mat-label>
        <input matInput
               value="{{contactObj?.supplyBasin}}"
               disabled
               name="supplyBasin"/>
      </mat-form-field>
    </div>
    <div fxLayout="row" *ngIf="(label !== 'Location' && confirmationInfo)" class="emptydiv">
    </div>
  </div>
</mat-card>
